import { ICellRendererParams, ValueFormatterParams } from "ag-grid-community";
import { GridType } from "../../../../../../types/grid";
import { convertToSentenceCase, formatCurrency, formatDateByType, formatNumber } from "../../../../../libs/utils";
import { vatInPercentage } from "../../../utils";
import { PaymentSchedule } from "./types";

export const previewScheduleColumns: GridType[] = [
  {
    id: "installments",
    field: "installments",
    headerName: "Installments",
    maxWidth: 130,
  },
  {
    id: "description",
    field: "description",
    headerName: "Payment Type",
    maxWidth: 160,
    valueFormatter: ({ value }: ValueFormatterParams<PaymentSchedule, PaymentSchedule["description"]>) => {
      return convertToSentenceCase(value);
    },
  },
  {
    id: "actualAmount",
    field: "actualAmount",
    headerName: "Amount",
    maxWidth: 170,
    type: "rightAligned",
    valueFormatter: ({ value, data }: ValueFormatterParams<PaymentSchedule, PaymentSchedule["actualAmount"]>) => {
      const amount = data?.isWriteOff ? -Math.abs(value) : value;
      return formatCurrency(amount);
    },
  },
  {
    id: "vat",
    field: "vat",
    headerName: "VAT",
    maxWidth: 170,
    type: "rightAligned",
    valueFormatter: ({ value }: ValueFormatterParams<PaymentSchedule, PaymentSchedule["vat"]>) => {
      return formatCurrency(value);
    },
  },
  {
    id: "vatInPercentage",
    field: "vatInPercentage",
    headerName: "VAT %",
    maxWidth: 100,
    type: "rightAligned",
    cellRenderer: ({ data }: ICellRendererParams<PaymentSchedule, PaymentSchedule["vat"]>) => {
      return formatNumber(vatInPercentage(data?.totalAmount, data?.actualAmount));
    },
  },
  {
    id: "totalAmount",
    field: "totalAmount",
    headerName: "Total Amount",
    maxWidth: 170,
    type: "rightAligned",
    valueFormatter: ({ value, data }: ValueFormatterParams<PaymentSchedule, PaymentSchedule["totalAmount"]>) => {
      const amount = data?.isWriteOff ? -Math.abs(value) : value;
      return formatCurrency(amount);
    },
  },
  {
    id: "dueDate",
    field: "dueDate",
    headerName: "Due Date",
    maxWidth: 120,
    valueFormatter: ({ value }: ValueFormatterParams<PaymentSchedule, PaymentSchedule["dueDate"]>) => {
      return formatDateByType(value);
    },
  },
];
